import {
  DecodedValueMap,
  QueryParamConfigMap,
  useCustomSearchParams,
} from 'common/hooks/customSearchParams';
import { DateSelector } from 'components/Selectors/DateSelector';
import * as React from 'react';
import { TerminalSelector, TimeSelector } from 'components/Selectors';
import moment from 'moment';
import { useRegion } from 'common/hooks/region';
import { TERMINAL_SCREENSHOTS_PARAMS } from '../params';

export const Filters: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(TERMINAL_SCREENSHOTS_PARAMS);
  const region = useRegion();

  const minDateString = region?.terminalScreenshotsMinDate;

  const onFilterChange = (values: Partial<DecodedValueMap<QueryParamConfigMap>>) => {
    setSearchParams(values);
  };

  return (
    <div className="flex space-x-4">
      <TerminalSelector
        value={searchParams.terminal}
        onChange={(terminal) => onFilterChange({ terminal })}
        onInitialLoad={(terminals) => {
          setSearchParams({
            terminal: terminals[0]?.key,
            date: moment(),
            time: moment().format('HH:mm'),
          });
        }}
      />
      <DateSelector
        label="Date"
        value={searchParams.date}
        onChange={(date) => onFilterChange({ date })}
        maxDate={moment().endOf('day')}
        minDate={minDateString ? moment(minDateString).startOf('day') : undefined}
      />
      <TimeSelector
        label="Time"
        value={searchParams.time || ''}
        onChange={(time) => onFilterChange({ time })}
      />
    </div>
  );
};
Filters.displayName = 'TerminalScreenshots.ByTerminal.Filters';
